import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";


export const ProtectedActionConfirmDialog = ({
  triggerLabel,
  title,
  message,
  onConfirm,
  testIdPrefix,
  triggerTestId,
  triggerVariant = "outline",
  triggerClassName = "",
  triggerDisabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [note, setNote] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    setError("");
    try {
      await onConfirm({ password, note: note.trim() || null });
      setOpen(false);
      setPassword("");
      setNote("");
    } catch (message) {
      setError(String(message));
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant={triggerVariant} className={triggerClassName} data-testid={triggerTestId || `${testIdPrefix}-trigger-button`} disabled={triggerDisabled}>{triggerLabel}</Button>
      </DialogTrigger>
      <DialogContent className="border-stone-200 bg-white/95" data-testid={`${testIdPrefix}-dialog`}>
        <DialogHeader>
          <DialogTitle data-testid={`${testIdPrefix}-title`}>{title}</DialogTitle>
          <DialogDescription data-testid={`${testIdPrefix}-message`}>{message}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          {error ? <p className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" data-testid={`${testIdPrefix}-error-message`}>{error}</p> : null}
          <Input type="password" placeholder="Confirm Super Admin password" value={password} onChange={(event) => setPassword(event.target.value)} data-testid={`${testIdPrefix}-password-input`} />
          <Textarea placeholder="Optional internal note" value={note} onChange={(event) => setNote(event.target.value)} data-testid={`${testIdPrefix}-note-input`} rows={4} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)} data-testid={`${testIdPrefix}-cancel-button`}>Cancel</Button>
          <Button onClick={handleConfirm} className="bg-[#8f1d1d] hover:bg-[#731414]" data-testid={`${testIdPrefix}-confirm-button`}>Confirm revoke</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};